module.exports = __webpack_public_path__ + "media/images/openweather/mapicons/ru-9a7af1d737567c0da17d9a55db1153fc.png";